module.exports = __webpack_public_path__ + "img/swap-top-banner.603eec6b.png";